module.exports = __webpack_public_path__ + "img/vector-20.fca72b97.svg";